module.exports = __webpack_public_path__ + "img/whatsapp.ae8a9a2f.png";